import userflow from "userflow.js";

import { getUserflowToken, isUserflowActive } from "./config";

if (isUserflowActive) {
  const token = getUserflowToken();
  if (token) {
    userflow.init(token);
  }
}
